
import { LocalStorageKeys } from '@/types/LocalStorageKeys';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LanguageSwitcher extends Vue {
  langs = [
    {
      lang: 'en',
      displayName: 'English',
    },
    {
      lang: 'es',
      displayName: 'Español',
    },
  ];

  toggleLanguage(localeCode: string) {
    localStorage.setItem(LocalStorageKeys.CWCB_LANGUAGE_SETTING, localeCode);
  }
}
